import JSX, { h, ComponentChildren } from 'preact'
import DropdownList from './DropdownList'
import Dropdown from './index'
import { GroupedItemsList, ItemsList } from './interfaces'

interface Props {
    type?: string,
    align: string,
    trigger: ComponentChildren,
    items: ItemsList | GroupedItemsList,
    displayListUpwards?: boolean,
    hasSearch?: boolean,
    triggerClass?: string,
    disabled?: boolean,
    children?: JSX.Element
}

const DropdownControl = ({ type, align, trigger, items, displayListUpwards, hasSearch, triggerClass, disabled, children }: Props) => {
  return (
    <Dropdown
      class={'control-dropdown'}
      trigger={trigger}
      triggerClass={triggerClass}
      disabled={disabled}
    >
      {({ close } : { close: () => void }) => children.length ? children[0]({ close }) : <DropdownList
        displayListUpwards={displayListUpwards}
        type={type}
        align={align}
        items={items}
        hasSearch={hasSearch || false}
      />
      }
    </Dropdown>
  )
}

export default DropdownControl
